export const colors = {
    primary: {
        lightest: '#f3f5f7',
        DEFAULT: '#3513e2',
        dark: '#3c008a'
    },
    secondary: {
        lightest: '#C2F5E4',
        DEFAULT: '#65efca',
        dark: '#5de1be',
        darkest : '#419e83'
    },
    neutral: {
        DEFAULT: '#f1f1f1'
    },
    lightPurple: {
        lightest: '#EEECF7',
        DEFAULT: '#E2C4FF',
        darkest: '#AB74E0'
    },
    apodisPink: {
        DEFAULT: '#e8DCFA'
    },
    darkPurple: {
        DEFAULT: '#3c008a'
    },
    darkBlue: {
        DEFAULT: '#3513e2'
    },
    gray: {
        light: "#F1F3F5",
        DEFAULT: '#cecece',
        dark: '#353535'
    },
    green: {
        DEFAULT: '#00dc86', light: '#65efca'
    },
    orange: {
        light: '#ffd7a4',
        DEFAULT: '#FFBC68',
    },
    pink: {
        light: '#ff80a280',
        DEFAULT: '#FF80A2',
        lighter: 'rgba(226, 196, 255, 0.3)'
    },
    red: {
        DEFAULT: '#ff2525',
        light: '#ED5252'
    },
    foreground: {
        DEFAULT: "hsl(222.2 84% 4.9%)"
    },
    muted: {
        DEFAULT: "hsl(210 40% 96.1%)",
        foreground: "hsl(215.4 16.3% 46.9%)"
    }
};
